import React, { lazy, Suspense } from "react";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import { LoginPage } from "./../pages/LoginPage/LoginPage";
import { ResetPasswordPage } from "./../pages/ResetPasswordPage/ResetPasswordPage";
import {
  CheckForMobileLayout,
  SuspenceLoader,
  PrivateRoute,
} from "../_components";
import { history } from "../_helpers";
import { roles } from "../_constants";

const DashboardPage = lazy(() =>
  import("../pages/DashboardPage/DashboardPage")
);

const App = () => {
  const { ROLE_ADMIN, ROLE_WATCHER, ROLE_SUPPORT, ROLE_ANALYZER } = roles;

  return (
    <Router history={history}>
      <Suspense fallback={<SuspenceLoader />}>
        <CheckForMobileLayout>
          <Switch>
            <PrivateRoute
              exact
              path="/dashboard/:path?/:id?"
              component={DashboardPage}
              roles={[ROLE_ADMIN, ROLE_WATCHER, ROLE_SUPPORT, ROLE_ANALYZER]}
            />
            <Route path="/login">
              <LoginPage />
            </Route>
            <Route path="/resetpassword">
              <ResetPasswordPage />
            </Route>
            <Route path="/unauthorized">
              <h1>403 Error</h1>
            </Route>
            <Redirect from="*" to="/dashboard" />
          </Switch>
        </CheckForMobileLayout>
      </Suspense>
    </Router>
  );
};

export { App };
